export const SET_SHOW_LONG_LOAD_PAGE_MESSAGE = 'SET_SHOW_LONG_LOAD_PAGE_MESSAGE';
export const SET_CUSTOM_LONG_LOAD_PAGE_MESSAGE = 'SET_CUSTOM_LONG_LOAD_PAGE_MESSAGE';

export const setShowLongLoadPageMessage = (flag) => ({
  type: SET_SHOW_LONG_LOAD_PAGE_MESSAGE,
  payload: { flag },
});

export const setCustomLongLoadPageMessage = (message) => ({
  type: SET_CUSTOM_LONG_LOAD_PAGE_MESSAGE,
  payload: { message },
});
